import React from 'react';
import Grid from '../layout/grid';

export default props => {
	return (
		<Grid cols={props.cols} style={{ minWidth: 165, maxWidth: 165 }}>
			<div className='form-group' style={{ marginBottom: props.marginBottom }}>
				{props.label &&
				<label htmlFor={props.name}>{props.label}</label>}
				<input {...props.input}
					className='form-control'
					maskChar={' '}
					style={{ fontSize: props.fontSize }}
					placeholder={props.placeholder}
					readOnly={props.readOnly} type={'date'}
					value={(props.value || '').split('/').join('-').split('T')[0]}
					onChange={data => props.onChange(data.target.value || null)} />
			</div>
		</Grid>
	);
}
